var _rect, _circle, _ellipse, _circle2, _circle3, _circle4, _circle5, _ellipse2, _circle6, _circle7, _circle8, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalianfood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    rx: 30,
    fill: "#C8A2C9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 172.347,
    cy: 94.7132,
    r: 42.6528,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 172,
    cy: 97.5,
    rx: 22,
    ry: 21.5,
    fill: "#3EC6F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 99,
    r: 11,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 90,
    r: 7,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.5,
    cy: 106.5,
    r: 5.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.0491,
    cy: 95.0491,
    r: 48.0491,
    fill: "white",
    stroke: "#C8A2C9",
    strokeWidth: 6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94,
    cy: 96.5,
    rx: 22,
    ry: 21.5,
    fill: "#3EC6F9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 98,
    r: 11,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 89,
    r: 7,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 105.5,
    r: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221 135C221 178.63 179.81 214 129 214C78.1898 214 37 178.63 37 135",
    stroke: "#905E92",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 137H28C28 137 31.9474 133.451 35.4483 133.043C39.9851 132.515 46 137 46 137Z",
    fill: "#905E92",
    stroke: "#905E92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230 137H212C212 137 215.947 133.451 219.448 133.043C223.985 132.515 230 137 230 137Z",
    fill: "#905E92",
    stroke: "#905E92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalianfood);
export default __webpack_public_path__ + "static/media/Italianfood.26a3cba6db5de28bb476dd0530c42407.svg";
export { ForwardRef as ReactComponent };